import { render, staticRenderFns } from "./DistributorBasicInfo.vue?vue&type=template&id=1338f150&scoped=true&"
import script from "./DistributorBasicInfo.vue?vue&type=script&lang=js&"
export * from "./DistributorBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./DistributorBasicInfo.vue?vue&type=style&index=0&id=1338f150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338f150",
  null
  
)

export default component.exports